import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/WechatIMG3219.jpg'
import _imports_1 from '@/assets/image/WechatIMG3220.jpg'
import _imports_2 from '@/assets/image/WechatIMG3221.jpg'


const _withScopeId = n => (_pushScopeId("data-v-3aa15c52"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"100%"},
  alt: ""
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"100%"},
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"width":"100%"},
  alt: "307"
}, null, -1))
const _hoisted_4 = { style: {"width":"110px"} }

import {reactive, onMounted, watch, computed} from "vue";
import {message, UploadFile} from "ant-design-vue";
import {AppstoreAddOutlined} from "@ant-design/icons-vue";
import dayjs, {Dayjs} from "dayjs";
import {Random} from "mockjs";
import BlockView from "@/components/block/BlockView.vue";
import BlockTitleView from "@/components/block/BlockTitleView.vue";
import AudioItem from "@/app/editor/modules/basic/v1/setup/AudioItem.vue";
import {BasicModuleV1} from "@/app/editor/modules/basic/v1/index";
import BlockContentBox from "@/components/block/BlockContentBox.vue";
import BlockContentItemKey from "@/components/block/BlockContentItemKey.vue";
import BlockContentItemValue from "@/components/block/BlockContentItemValue.vue";
import ImagePickItem from "@/app/editor/views/ImagePickItem.vue";
import {ITheme} from "@/app/editor/theme";
import {account} from "@/app/login";
import {IconFont, Json, req} from "@/lib/util";
import {editor} from "@/app/editor";
import ThemeImageTemplatePreView from "@/app/editor/modules/basic/v1/views/ThemeImageTemplatePreView.vue";
import {IImageTemplateDrawOption} from "@/app/editor/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicStyleSetup',
  props: {
    index: {}
  },
  setup(__props: any) {

const props = __props
let basic = editor.activity?.modules[props.index] as BasicModuleV1

const info = reactive({
  data: {key: '', token: ''},
  recommendTitles: {list: [] as string[], loading: false},
  music: {show: false},
  virtual: {show: false},
  themes: {show: false},
  theme: {thumb: false, poster: false}
})

info.virtual.show = !(basic.config.props.virtual.view == 0 && basic.config.props.virtual.sign == 0 && basic.config.props.virtual.share == 0 && basic.config.props.virtual.pay == 0)

onMounted(() => {
  basic = editor.activity?.modules[props.index] as BasicModuleV1
  editor.activity?.refresh()
  editor.activity?.loadShowThemes()
})

watch(() => info.virtual.show, v => {
  if (v) {
    basic.config.props.virtual.sign = Math.round(Random.integer(100, 200))
    basic.config.props.virtual.view = Math.round(basic.config.props.virtual.sign * 12.32)
    basic.config.props.virtual.share = Math.round(basic.config.props.virtual.sign * 2.56)
    basic.config.props.virtual.pay = Math.round(basic.config.props.virtual.sign * 0.84)
  } else {
    basic.config.props.virtual.view = 0
    basic.config.props.virtual.sign = 0
    basic.config.props.virtual.share = 0
    basic.config.props.virtual.pay = 0
  }
})

const imageOptions = computed((): IImageTemplateDrawOption[] => {
  const d = editor.activity?.data
  if (!d) return []
  const t = d.themes.find(i => i.theme_id == basic.config.theme.theme_id)
  if (!t) return []
  let arr = [] as IImageTemplateDrawOption[]
  basic.config.theme.theme_options[t.head_image_template_id]?.forEach(i => arr.push(i))
  return arr
})

const thumbImageOptions = computed((): IImageTemplateDrawOption[] => {
  const d = editor.activity?.data
  if (!d) return []
  const t = d.themes.find(i => i.theme_id == basic.config.theme.theme_id)
  if (!t) return []
  let arr = [] as IImageTemplateDrawOption[]
  basic.config.theme.theme_options[t.applet_share_thumb_image_template_id]?.forEach(i => arr.push(i))
  return arr
})

const posterImageOptions = computed((): IImageTemplateDrawOption[] => {
  const d = editor.activity?.data
  if (!d) return []
  const t = d.themes.find(i => i.theme_id == basic.config.theme.theme_id)
  if (!t) return []
  let arr = [] as IImageTemplateDrawOption[]
  basic.config.theme.theme_options[basic.config.theme.applet_poster_id]?.forEach(i => arr.push(i))
  return arr
})

const beforeUpload = (f: File): Promise<File> | boolean => {
  if (!account.shop?.sid) {
    message.warn({content: '账号异常，请重新登录'})
    return false
  }

  info.data.key = `media/temp/${Math.random().toString(36).slice(2)}.${f.name.split('.').pop()}`
  if (f.name.endsWith('mp3')) {
    if (f.size > 10 * 1000 * 1000) {
      message.warn({content: '文件尺寸过大'})
      return false
    }
  } else {
    message.warn({content: '图片尺寸过大'})
    return false
  }
  return new Promise((resolve, reject) => {
    req({
      url: 'fs/token', method: 'POST', data: {key: info.data.key}, success: rs => {
        info.data.token = rs.token
        resolve(f)
      }, fail: reject
    })
  })
}

const onUploadChange = (j: Json) => {
  const f = j.file as UploadFile
  if (f.status == 'done') {
    f.url = 'https://activity.guandb.cn/' + f.response.key
    if (basic) basic.config.music_url = f.url
  }
}

const setNoMusic = () => {
  if (!basic) return
  basic.config.music_url = ''
  basic.audio.pause()
  basic.audio.src = ''
  basic.data.audio_status = false
}

const setMusic = (url: string) => {
  if (!basic) return
  basic.config.music_url = url
  basic.data.audio_url = url
  basic.audio.src = url
  basic.audio.play()
  basic.audio.loop = true
}

const disabledDate = (date: Dayjs) => {
  if (editor.activity?.isEdit()) return date.diff(editor.activity?.data.start_at, 'days') > 30

  if (editor.activity?.status.date_range.length == 0) return false
  const tooLate = editor.activity?.status.date_range[0] && date.diff(editor.activity?.status.date_range[0], 'days') > 30
  const tooEarly = editor.activity?.status.date_range[1] && editor.activity?.status.date_range[1].diff(date, 'days') > 30
  return tooEarly || tooLate
}

const onClickThemeItem = (evt: Event, themeId: string) => {
  basic.config.themes.includes(themeId) ? basic.config.themes.splice(basic.config.themes.indexOf(themeId), 1) : basic.config.themes.length < 4 ? basic.config.themes.push(themeId) : ''

  editor.activity?.loadShowThemes()
}
const onShowAllTheme = () => {
  editor.activity?.loadAllThemes()
  info.themes.show = true
}

const onChangeTheme = (evt: Event, t: ITheme) => {
  if (basic.config.theme.theme_id == t.theme_id) return
  basic.themeSwitch(t.theme_id, message.loading('加载中', 0))
}

const onSelectThumb = () => {
  const id = editor.activity?.data.themes.find(t => t.theme_id == basic.config.theme.theme_id)?.applet_share_thumb_image_template_id
  if (id) {
    editor.activity?.loadWxThumbImages(id)
  }
  info.theme.thumb = true
}

const onPickThumbVersion = (v: number) => {
  basic.config.theme.applet_thumb_version = v
}

const onPickPoster = (iid: string) => {
  basic.config.theme.applet_poster_id = iid
}
const onSelectPoster = () => {
  editor.activity?.data.themes.find(t => t.theme_id == basic.config.theme.theme_id)?.applet_poster_image_template_ids.forEach(id => {
    editor.activity?.inQueue(id, 0)
  })
  info.theme.poster = true
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_unref(basic) && _unref(editor).activity)
    ? (_openBlock(), _createBlock(BlockView, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(BlockTitleView, null, {
            default: _withCtx(() => [
              _createVNode(_unref(IconFont), {
                type: `icon-${_unref(basic).icon}`,
                style: {"padding-right":"8px"}
              }, null, 8, ["type"]),
              _createTextVNode(" " + _toDisplayString(_unref(basic).title), 1)
            ]),
            _: 1
          }),
          _createVNode(BlockContentBox, null, {
            default: _withCtx(() => [
              _createVNode(BlockContentItemKey, null, {
                default: _withCtx(() => [
                  _createTextVNode("主题样式")
                ]),
                _: 1
              }),
              _createVNode(BlockContentItemValue, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_flex, {
                    vertical: "vertical",
                    gap: "middle"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_flex, { gap: "middle" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editor).activity.data.themes.filter(i => _unref(basic).config.themes.includes(i.theme_id)), (t) => {
                            return (_openBlock(), _createBlock(ImagePickItem, {
                              key: t.theme_id,
                              "is-pick": t.theme_id==_unref(basic).config.theme.theme_id,
                              onClick: ($event: any) => (onChangeTheme($event,t)),
                              image: _unref(editor).activity.images[t.head_image_template_id+0],
                              height: "116px",
                              width: "116px"
                            }, null, 8, ["is-pick", "onClick", "image"]))
                          }), 128)),
                          (_unref(account).user?.is_master)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "dashed",
                                size: "large",
                                style: {"width":"114px","height":"120px"},
                                onClick: onShowAllTheme
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_unref(AppstoreAddOutlined), { style: {"font-size":"40px"} })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_flex, {
                        align: "center",
                        gap: "small"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageOptions.value, (t, k) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                              _createTextVNode(_toDisplayString(t.title) + ": ", 1),
                              _createVNode(_component_a_input, {
                                value: _unref(basic).config.theme.theme_options[t.image_template_id][k].text,
                                onChange: ($event: any) => (_unref(basic).onOptionChange($event,t.image_template_id,k)),
                                maxlength: t.length_max<t.length_min?t.length_min:t.length_max,
                                "allow-clear": "",
                                "show-count": "",
                                status: t.text.length<t.length_min ? 'error' : '',
                                style: {"width":"30%"}
                              }, null, 8, ["value", "onChange", "maxlength", "status"])
                            ], 64))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_flex, { gap: "large" }, {
                        default: _withCtx(() => [
                          _createVNode(ThemeImageTemplatePreView, {
                            title: `样式${_unref(basic).config.theme.applet_thumb_version}`,
                            "sub-title": "分享卡片封面",
                            image: _unref(editor).activity.images[_unref(editor).activity.data.themes.find(t => t.theme_id==_unref(basic).config.theme.theme_id)?.applet_share_thumb_image_template_id+_unref(basic).config.theme.applet_thumb_version],
                            options: thumbImageOptions.value,
                            basic: _unref(basic),
                            onOnChange: onSelectThumb
                          }, null, 8, ["title", "image", "options", "basic"]),
                          _createVNode(ThemeImageTemplatePreView, {
                            title: `样式${_unref(editor).activity.data.themes.find(t => t.theme_id == _unref(basic).config.theme.theme_id)?.applet_poster_image_template_ids?.indexOf(_unref(basic).config.theme.applet_poster_id)+1}`,
                            "sub-title": "分享海报",
                            image: _unref(editor).activity.images[_unref(basic).config.theme.applet_poster_id+0],
                            options: posterImageOptions.value,
                            basic: _unref(basic),
                            onOnChange: onSelectPoster
                          }, null, 8, ["title", "image", "options", "basic"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_unref(account).user?.is_master)
                ? (_openBlock(), _createBlock(BlockContentItemKey, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("活动标题")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(account).user?.is_master)
                ? (_openBlock(), _createBlock(BlockContentItemValue, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _unref(basic).config.title_id,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(basic).config.title_id) = $event)),
                        style: {"width":"100%"},
                        options: _unref(editor).activity.data.titles.map(i => ({label:_unref(editor).activity?.previewTitle(i.title),value:i.title_id}))
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(BlockContentItemKey, null, {
                default: _withCtx(() => [
                  _createTextVNode("活动时间")
                ]),
                _: 1
              }),
              _createVNode(BlockContentItemValue, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_range_picker, {
                    value: _unref(editor).activity.status.date_range,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(editor).activity.status.date_range) = $event)),
                    "disabled-date": disabledDate,
                    onCalendarChange: _cache[2] || (_cache[2] = v => _unref(editor).activity!.status.date_range = v),
                    allowClear: false,
                    disabled: _unref(editor).activity.isEdit() ? [true,false] : [false,false]
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(BlockContentItemKey, null, {
                default: _withCtx(() => [
                  _createTextVNode("背景音乐")
                ]),
                _: 1
              }),
              _createVNode(BlockContentItemValue, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (info.music.show=true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IconFont), {
                        type: `icon${_unref(basic).config.music_url ? '' : '-no'}-music`
                      }, null, 8, ["type"]),
                      _createTextVNode(" " + _toDisplayString(_unref(basic).musicName(_unref(basic).config.music_url)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(BlockContentItemKey, null, {
                default: _withCtx(() => [
                  _createTextVNode("虚拟基数")
                ]),
                _: 1
              }),
              _createVNode(BlockContentItemValue, null, {
                default: _withCtx(() => [
                  _createVNode(BlockContentBox, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio_group, {
                            value: info.virtual.show,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((info.virtual.show) = $event)),
                            options: [{label:'开启',value:true},{label:'关闭',value:false}]
                          }, null, 8, ["value"]),
                          _createVNode(_component_a_tooltip, { class: "tip-text" }, {
                            title: _withCtx(() => [
                              _hoisted_1
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" 查看示例 ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (info.virtual.show)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 0,
                            span: 24
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_space, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input_number, {
                                    value: _unref(basic).config.props.virtual.view,
                                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(basic).config.props.virtual.view) = $event)),
                                    "addon-before": "浏览基数",
                                    "addon-after": "次"
                                  }, null, 8, ["value"]),
                                  _createVNode(_component_a_input_number, {
                                    value: _unref(basic).config.props.virtual.sign,
                                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(basic).config.props.virtual.sign) = $event)),
                                    "addon-before": "报名基数",
                                    "addon-after": "人"
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (info.virtual.show)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 1,
                            span: 24
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_space, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input_number, {
                                    value: _unref(basic).config.props.virtual.share,
                                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(basic).config.props.virtual.share) = $event)),
                                    "addon-before": "分享基数",
                                    "addon-after": "次"
                                  }, null, 8, ["value"]),
                                  _createVNode(_component_a_input_number, {
                                    value: _unref(basic).config.props.virtual.pay,
                                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(basic).config.props.virtual.pay) = $event)),
                                    "addon-before": "成交基数",
                                    "addon-after": "单"
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_collapse, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_collapse_panel, { header: "更多" }, {
                        default: _withCtx(() => [
                          _createVNode(BlockContentBox, null, {
                            default: _withCtx(() => [
                              _createVNode(BlockContentItemKey, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("围观头像")
                                ]),
                                _: 1
                              }),
                              _createVNode(BlockContentItemValue, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_radio_group, {
                                    value: _unref(basic).config.props.show_statistics,
                                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_unref(basic).config.props.show_statistics) = $event)),
                                    options: [{label:'开启',value:true},{label:'关闭',value:false}]
                                  }, null, 8, ["value"]),
                                  _createVNode(_component_a_tooltip, { class: "tip-text" }, {
                                    title: _withCtx(() => [
                                      _hoisted_2
                                    ]),
                                    default: _withCtx(() => [
                                      _createTextVNode(" 查看示例 ")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(BlockContentItemKey, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("弹幕")
                                ]),
                                _: 1
                              }),
                              _createVNode(BlockContentItemValue, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_radio_group, {
                                    value: _unref(basic).config.props.show_barrage,
                                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_unref(basic).config.props.show_barrage) = $event)),
                                    options: [{label:'开启',value:true},{label:'关闭',value:false}]
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(BlockContentItemKey, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("购买记录")
                                ]),
                                _: 1
                              }),
                              _createVNode(BlockContentItemValue, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_radio_group, {
                                    value: _unref(basic).config.props.is_show_pay_history,
                                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_unref(basic).config.props.is_show_pay_history) = $event)),
                                    options: [{label:'开启',value:true},{label:'关闭',value:false}]
                                  }, null, 8, ["value"]),
                                  _createVNode(_component_a_tooltip, { class: "tip-text" }, {
                                    title: _withCtx(() => [
                                      _createTextVNode(" 显示用户下单购买记录 "),
                                      _hoisted_3
                                    ]),
                                    default: _withCtx(() => [
                                      _createTextVNode(" 查看示例 ")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_drawer, {
            open: info.music.show,
            "onUpdate:open": _cache[12] || (_cache[12] = ($event: any) => ((info.music.show) = $event)),
            title: "背景音乐",
            placement: "right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, {
                direction: "vertical",
                class: "music-option"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_upload, {
                    accept: ".mp3",
                    data: info.data,
                    "before-upload": beforeUpload,
                    action: "https://upload.qiniup.com",
                    "max-count": 1,
                    onChange: onUploadChange
                  }, {
                    itemRender: _withCtx(({file}) => [
                      (file.status == 'done')
                        ? (_openBlock(), _createBlock(AudioItem, {
                            key: 0,
                            name: "自定义音乐",
                            active: _unref(basic).config.music_url == file.url,
                            url: file.url,
                            "play-stat": _unref(basic).data.audio_url == file.url && _unref(basic).data.audio_status,
                            onClick: ($event: any) => (_unref(basic).config.music_url=file.url)
                          }, null, 8, ["active", "url", "play-stat", "onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { size: "large" }, {
                        default: _withCtx(() => [
                          _createTextVNode("上传")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  (_unref(basic).config.music_url)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        size: "large",
                        onClick: setNoMusic
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("不用音乐")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_a_tabs, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(basic).musicLibrary, (c) => {
                    return (_openBlock(), _createBlock(_component_a_tab_pane, {
                      key: c.name,
                      tab: c.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_list, {
                          "data-source": c.data,
                          pagination: {defaultPageSize:10,hideOnSinglePage:true,showSizeChanger:false}
                        }, {
                          renderItem: _withCtx(({ item }) => [
                            _createVNode(AudioItem, {
                              active: _unref(basic).config.music_url == item.url,
                              url: item.url,
                              name: item.name,
                              "play-stat": _unref(basic).data.audio_url == item.url && _unref(basic).data.audio_status,
                              onClick: ($event: any) => (setMusic(item.url))
                            }, null, 8, ["active", "url", "name", "play-stat", "onClick"])
                          ]),
                          _: 2
                        }, 1032, ["data-source"])
                      ]),
                      _: 2
                    }, 1032, ["tab"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["open"]),
          _createVNode(_component_a_drawer, {
            open: info.themes.show,
            "onUpdate:open": _cache[13] || (_cache[13] = ($event: any) => ((info.themes.show) = $event)),
            title: "主题样式",
            placement: "right",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_flex, {
                wrap: "wrap",
                gap: "middle"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editor).activity.data.themes.sort((a,b) => a.internal_name.localeCompare(b.internal_name)), (t) => {
                    return (_openBlock(), _createBlock(_component_a_flex, {
                      vertical: "",
                      gap: "small",
                      align: "center",
                      key: t.theme_id
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ImagePickItem, {
                          image: _unref(editor).activity.images[t.head_image_template_id+0],
                          "is-pick": _unref(basic).config.themes.includes(t.theme_id),
                          onClick: ($event: any) => (onClickThemeItem($event,t.theme_id)),
                          height: "110px",
                          width: "110px"
                        }, null, 8, ["image", "is-pick", "onClick"]),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(t.internal_name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["open"]),
          _createVNode(_component_a_modal, {
            open: info.theme.thumb,
            "onUpdate:open": _cache[15] || (_cache[15] = ($event: any) => ((info.theme.thumb) = $event)),
            title: "选择分享卡片封面"
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (info.theme.thumb = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("完成")
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_flex, {
                wrap: "wrap",
                gap: "middle"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(6).fill(null).map((_,ii) => ii+1), (v) => {
                    return (_openBlock(), _createBlock(ImagePickItem, {
                      key: v,
                      image: _unref(editor).activity.images[(_unref(editor).activity.data.themes.find(t => t.theme_id==_unref(basic).config.theme.theme_id)?.applet_share_thumb_image_template_id + v)],
                      "is-pick": _unref(basic).config.theme.applet_thumb_version == v,
                      onClick: ($event: any) => (onPickThumbVersion(v)),
                      height: "110px",
                      width: "auto"
                    }, null, 8, ["image", "is-pick", "onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["open"]),
          _createVNode(_component_a_modal, {
            open: info.theme.poster,
            "onUpdate:open": _cache[17] || (_cache[17] = ($event: any) => ((info.theme.poster) = $event)),
            title: "选择分享卡片封面"
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (info.theme.poster = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("完成")
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_flex, {
                wrap: "wrap",
                gap: "middle"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editor).activity.data.themes.find(t => t.theme_id==_unref(basic).config.theme.theme_id)?.applet_poster_image_template_ids, (iid) => {
                    return (_openBlock(), _createBlock(ImagePickItem, {
                      key: iid,
                      image: _unref(editor).activity.images[iid+0],
                      "is-pick": _unref(basic).config.theme.applet_poster_id == iid,
                      onClick: ($event: any) => (onPickPoster(iid)),
                      height: "240px",
                      width: "auto"
                    }, null, 8, ["image", "is-pick", "onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["open"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})